import { LoadableAfterPaint } from '@confluence/loadable';

export const GlobalQuestionsListMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalQuestionsListMacroHandler" */ '../src/GlobalQuestionsListMacroHandler.tsx'
			)
		).GlobalQuestionsListMacroHandler,
});
